import { render, staticRenderFns } from "./GeneralBlank.vue?vue&type=template&id=135a5466&scoped=true&"
import script from "./GeneralBlank.vue?vue&type=script&lang=js&"
export * from "./GeneralBlank.vue?vue&type=script&lang=js&"
import style0 from "./GeneralBlank.vue?vue&type=style&index=0&id=135a5466&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "135a5466",
  null
  
)

export default component.exports